var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('register-ctrl',{attrs:{"projectName":_vm.projectName,"projectLogo":_vm.projectLogo},on:{"registerButtonClick":_vm.registerButtonClick,"loginTextClick":_vm.loginTextClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-193d0c66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./third_party/common_app/LoginModule/View/Area/RegisterArea.vue
// module id = null
// module chunks = 